module.exports = __webpack_public_path__ + "assets/img/警报.96a4bd21.svg";